const strings = {
  addUser: 'Adicionar',
}

export default strings
